import React, { memo } from "react";
import { useSelector } from "react-redux";
import { NavLink, useLocation } from "react-router-dom";
import { FiPlusCircle, FiCreditCard, FiHome, FiShoppingCart, FiBell } from "react-icons/fi";
import { useTranslation } from "../i18n";

const BottomMenu = memo(() => {
  const location = useLocation();
  const countNoty = useSelector((state) => state.ui.countNoty);
  const { t } = useTranslation();

  const items = [
    { to: "/", Icon: FiHome, label: t("nav.home") },
    { to: "/wallet", Icon: FiCreditCard, label: t("nav.wallet") },
    { to: "/deposit", Icon: FiPlusCircle, label: t("nav.balance"), cta: true },
    { to: "/orders", Icon: FiShoppingCart, label: t("nav.orders") },
    { to: "/noty", Icon: FiBell, label: t("nav.notifications"), badge: countNoty },
  ];

  return (
    <nav className="bottom-bar" id="bottomBar">
      {items.map(({ to, Icon, label, badge, cta }) => (
        <NavLink
          key={to}
          className={({ isActive }) =>
            "bottom-item" + (cta ? " bottom-item--cta" : "") + (isActive ? " is-active" : "")
          }
          data-page={to.replace("/", "") || "index"}
          to={to}
        >
          <span className="ico">
            <Icon size={cta ? 24 : 22} />
            {badge > 0 && <span className="dot" />}
          </span>
          <span>{label}</span>
        </NavLink>
      ))}
    </nav>
  );
});

export default BottomMenu;
